import React from "react";
import { Row, Col } from "react-bootstrap";
import Title from "../Title/Title";
import "./Portfolio.scss";

const portfolioItems = [
  {
    image: require("../../assets/portfolio/AXPC.png"),
    title: "American Exploration and Production Council",
    description: "Architected and developed the comprehensive member intelligence platform and enterprise AI Assistant, featuring upstream safety benchmarking and ESG emissions analytics."
  },
  {
    image: require("../../assets/portfolio/ISAS.png"),
    title: "Independent Schools Association of the Southwest",
    description: "On going updates and maintenance of their web based accreditation software."
  },
  {
    image: require("../../assets/portfolio/VGLNG.png"),
    title: "Venture Global LNG",
    description: "Architected and deployed a mission-critical, cloud-native operational logistics and facility access platform for export terminal operations, featuring real-time GIS tracking, contractor credentialing, and gate attendant PWAs."
  },
  {
    image: require("../../assets/portfolio/CLP.png"),
    title: "CaseLoggerPro",
    description: "We transformed and modernized the medical anesthesia case logging app, migrating it from an outdated, failing platform to a robust, user-friendly web and mobile solution optimized for performance and reliability."
  },
  {
    image: require("../../assets/portfolio/GCR.png"),
    title: "GetCarRide",
    description: "We developed and implemented a digital transportation booking platform that streamlines reservations, enhances user experience, and simplifies operations for both customers and service providers."
  },
  {
    image: require("../../assets/portfolio/Odin.png"),
    title: "Odin System",
    description: "Designed and developed a web-based platform enabling efficient monitoring, configuration, and management of IoT devices through an intuitive, centralized console."
  }
];

export default function Portfolio() {
  return (
    <section className="section-bg section py-5" id="portfolio">
      <div className="container">
        <Row className="py-5">
          <Col xs={12} data-aos="fade-up" data-aos-duration="500">
            <Title
              regular_text="Our Recent"
              highlighted_text="Customers"
            />
          </Col>
        </Row>
        <Row className="mx-auto">
          {portfolioItems.map((item, index) => (
            <Col
              key={index}
              xs={12}
              md={6}
              lg={4}
              className="d-flex mb-4"
              data-aos="fade-up"
              data-aos-duration="500"
              data-aos-delay={index * 100}
            >
              <div className="portfolio-block w-100">
                <img src={item.image} alt={item.title} className="img-fluid" />
                <div className="caption">
                  <h4>{item.title}</h4>
                  <p className="mb-0">{item.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}
